import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import {
  HpaJourneyShell,
  HpaSynthesisState,
  SYNTHESIS_LINE_COUNT,
} from "./components";
import "./hpa.css";
import "./hpa-assessment.css";

/**
 * Block 11.2 · § 31 · Mentor Review Pending
 * Auch als Synthesis-Wait-Anzeige verwendbar (§ 28) — nach Finalize navigiert
 * der Assessment-Screen direkt hierher.
 *
 * Zeigt eine ruhige Sequenz. Es gibt KEINE Fake-Progressbar (§ 29).
 * Nach Ablauf der Sequenz bleibt die "Mentor prüft"-Nachricht bestehen.
 */
const STEP_MS = 2400;

export default function HpaReviewPending() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (activeIndex < SYNTHESIS_LINE_COUNT) {
      const t = setTimeout(() => {
        if (activeIndex === SYNTHESIS_LINE_COUNT - 1) {
          setDone(true);
        } else {
          setActiveIndex((i) => i + 1);
        }
      }, STEP_MS);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [activeIndex]);

  return (
    <>
      <SEO
        title="HPA · Dein Profil wird vervollständigt"
        description="HPA Review Pending"
        path="/hpa/review-pending"
      />
      <HpaJourneyShell testid="hpa-review-pending" pulsingThread>
        <div className="hpa-overline mb-6">SAT HPA™ · Synthese</div>

        {!done ? (
          <>
            <h1
              className="hpa-headline text-3xl md:text-4xl mb-12"
              data-testid="hpa-review-pending-synthesis"
            >
              Dein persönliches HPA-Profil <em>entsteht</em>.
            </h1>
            <HpaSynthesisState activeIndex={activeIndex} />
          </>
        ) : (
          <>
            <h1
              className="hpa-headline text-3xl md:text-4xl mb-8"
              data-testid="hpa-review-pending-headline"
            >
              Dein Profil wird <em>vervollständigt</em>.
            </h1>
            <p className="hpa-lede text-base md:text-lg leading-relaxed max-w-xl mb-14">
              Deine HPA wurde erfolgreich erstellt. Ein berechtigter SAT
              Mentor prüft die Auswertung, bevor dein persönliches Profil für
              dich freigegeben wird.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5">
              <Link
                to="/hpa"
                className="hpa-btn-primary"
                data-testid="hpa-review-pending-cta-home"
              >
                Zur HPA-Übersicht
              </Link>
            </div>
          </>
        )}
      </HpaJourneyShell>
    </>
  );
}
